import React, { Fragment } from 'react';
import { Image } from '@sencha/ext-modern'

export default function logo(props) {
  const { title } = props
  return (
    <Fragment>
      {!Ext.os.is.Phone && <Image mode="" width="18" src="resources/qrCode.png" docked="top" padding={5}/>}
      <Image mode="" height="50" src="resources/logo.gif" />
      <h2 align="center">{title}</h2>
    </Fragment>
  )
}